<template>
  <div class="elevation-4  bc-white">
    <v-row class="ma-0" justify="center" v-if="!type">
      <v-col cols="12" sm="6" class="pa-1">
        <v-date-picker
          v-model="dateFrom"
          flat
          width="100%"
          :first-day-of-week="1"
          :max="dateTo"
          :color="pickerColor"
          :header-color="pickerEventColor"
          :event-color="pickerEventColor"
          :events="events[0]"
        ></v-date-picker>
      </v-col>
      <v-col cols="12" sm="6" class="pa-1">
        <v-date-picker
          v-model="dateTo"
          flat
          width="100%"
          :first-day-of-week="1"
          :min="dateFrom"
          :color="pickerColor"
          :header-color="pickerEventColor"
          :event-color="pickerEventColor"
          :events="events[1]"
        >
        </v-date-picker>
      </v-col>
    </v-row>
    <v-row class="ma-0" justify="center" v-else>
      <v-col cols="12" sm="12" class="pa-1">
        <v-date-picker
          v-model="monthDateRange"
          :type="type"
          :color="pickerColor"
          :header-color="pickerEventColor"
          :event-color="pickerEventColor"
          range
        ></v-date-picker>
      </v-col>
    </v-row>
    <v-row v-if="showButtons" class="ma-0">
      <v-spacer></v-spacer>
      <v-btn
        small
        outlined
        class="my-1"
        color="primary"
        @click="onCancelClick"
      >
        Cancel
      </v-btn>
      <v-btn
        small
        class="mx-1 my-1"
        color="primary"
        @click="onOkClick"
      >
        OK
      </v-btn>
    </v-row>
  </div>
</template>
<script>
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'RangeDatePicker',
  props: {
    value: {
      required: false
    },
    menuModel: {
      required: true
    },
    showButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    type: {
      required: false
    }
  },
  mounted () {
    this.$emit('input', [this.dateFrom, this.dateTo])
  },
  computed: {
    parsedValue () {
      const currentValue = this.value || []
      if (typeof currentValue === 'string') {
        const res = currentValue.split(',')
        return res.length === 2 ? res : [res[0], formatLocalDate()]
      } else {
        return currentValue
      }
    },
    dateFrom: {
      get () {
        return this.parseInputValue(this.parsedValue[0])
      },
      set (val) {
        this.$emit('input', [val, this.dateTo])
      }
    },
    dateTo: {
      get () {
        return this.parseInputValue(this.parsedValue[1])
      },
      set (val) {
        this.$emit('input', [this.dateFrom, val])
      }
    },
    monthDateRange: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    events () {
      const daysBetween = (+(new Date(this.dateTo)) - +(new Date(this.dateFrom))) / (1000 * 3600 * 24)
      const evnts = []
      for (let i = 0; i <= daysBetween; i++) {
        const dateFrom = new Date(this.dateFrom)
        const newDate = dateFrom.setDate(dateFrom.getDate() + i)
        evnts.push(formatLocalDate(new Date(newDate)))
      }
      return [evnts.slice(1, evnts.length - 1), evnts.splice(0, evnts.length - 1)]
    },
    pickerEventColor () {
      return this.$vuetify.theme.dark ? 'blue darken-1' : 'primary'
    },
    pickerColor () {
      return this.$vuetify.theme.dark ? 'blue darken-1' : 'accent'
    }
  },
  methods: {
    onCancelClick () {
      this.$emit('onCancelClick')
    },
    onOkClick () {
      this.$emit('onOkClick', this.value)
    },
    onDateMenuClose () {
      this.$emit('onDateMenuClose')
    },
    parseInputValue (val) {
      if (val) {
        const splited = val.split('-')
        if (splited[0] && +splited[0] < 1921) {
          splited[0].split('-')[0] = '1921'
        }
        if (splited[1] && !+splited[1]) {
          splited[1] = '01'
        }
        if (splited[2] && !+splited[2]) {
          splited[2] = '01'
        }
        return splited.length === 3 ? splited.join('-') : formatLocalDate()
      }
      return formatLocalDate()
    }
  },
  watch: {
    menuModel (newVal) {
      if (newVal === false) {
        this.$emit('input', [this.dateFrom, this.dateTo])
        this.onDateMenuClose()
      }
    }
  }
}
</script>
<style lang="scss">
  @media screen and (max-width: 480px) {
    .bc-white {
      background-color: #F7F7F7;
    }
  }
  .v-date-picker-table {
    height: 285px;
  }
</style>
